import { setupMutationTypes } from './mutation-types';

export const mutations = {
  [setupMutationTypes.BENCHMARKS_LIST_LOADING] (state, loading) {
    state.benchmarksList.isLoading = loading;
  },
  [setupMutationTypes.BENCHMARKS_LIST_ERROR] (state, error) {
    state.benchmarksList.hasError = error;
  },
  [setupMutationTypes.BENCHMARKS_LIST_DATA] (state, { data }) {
    state.benchmarksList.data = data;
  },
  [setupMutationTypes.ADD_BENCHMARKS_PERIOD] (state, { selectedPeriod }) {
    state.activeBenchmarksPeriod = selectedPeriod;
  },
  [setupMutationTypes.UPDATE_BENCHMARKS_LOADING] (state, loading) {
    state.benchmarksUpdate.isLoading = loading;
  },
  [setupMutationTypes.UPDATE_BENCHMARKS_ERROR] (state, error) {
    state.benchmarksUpdate.hasError = error;
  },
};
